// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"65":"ef7bfa67","75":"d67269eb","99":"d2f94c42","253":"86b542d5","744":"d7c1d124"}[chunkId] + ".css";
};